module.exports = __webpack_public_path__ + "img/network-map.b43ce37c.png";